import { graphql } from 'react-relay';
export const setOnboardingStateGQL = graphql`
	mutation OnboardingStatusMutation($states: [OnboardingStateInput!]!) {
		setOnboardingState(states: $states) {
			key
			value
		}
	}
`;
